export const verificarObligatorias = (arrCalificaciones, obligatorias) =>{


    let arrIds = obligatorias.map((e) => e.id)


    if (arrCalificaciones.length === 0){
        return false
    }

    let calisObligatorias = arrCalificaciones.filter((e) => arrIds.includes(e.idCapacitacion))

   // console.log(calisObligatorias)

    let numRespuestas = 0
    let numPuntos = 0
    for (let i = 0; i < calisObligatorias.length; i++) {
        let calificacion = calisObligatorias[i]
        let respuestas = calificacion.calificaciones

        for (let j = 0; j < respuestas.length;  j++) {
            numRespuestas++
            if (respuestas[j].punto){
                numPuntos++
            }
        }


    }

    if (numPuntos === 0){
        return false
    }
    //Sacamos promedio

    let prom = (numPuntos * 100) / numRespuestas

    if (prom === 100){
        return true
    }else{
        return false
    }

}